<template>
  <div v-if="campagne">
     <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column max-width-60vw">
              <h1 class="title is-size-3">
                {{ $t('detailCampagne.title',
                { libelle: campagne.libelle }) }}
                <b-tag v-if="!campagne.actif"
                  type="has-background-subMenu"
                  class="has-text-white mgl-5px">
                  {{$t('detailCampagne.campagneArchivee')}}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">

          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="permCampagne.maj"
            :actions="actionSecondary"
            @click="() => {
              $router.push({ name: 'm.bodac.campagne-edit', params: { id: campagne.id }});
            }">
              {{ $t('general.button.edit') }}
          </dropdownButton>

            <piece-jointe-button
              class="mgr-2"
              :perm="permCampagne.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>

    <onglet-manager
      v-if="campagne"
      class="mgt-20px"
      :onglets="onglets">
      <template #detailCampagne>
        <detail-campagne :campagne="campagne" />
      </template>
      <template #demandeImpression>
        <store-recherche-provider
          name="demandeImpressionCampagne"
          :copy="demandeImpressionStore"
          :copyChanges="changesDemandeImpressionStore()"
          :isTemporary="true">
          <liste-demande-impression-onglet
            :isCampagne="true"/>
        </store-recherche-provider>
      </template>
    </onglet-manager>

    <b-modal v-model="isPopUpArchiver"
      has-modal-card
      class="modal">
      <pop-up-prevention v-if="isPopUpArchiver"
        :messHeader="campagne.actif ? $t('listeCampagnes.archiverDesarchiver.archive')
         : $t('listeCampagnes.archiverDesarchiver.desarchive')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="isPopUpArchiver = false"
        @yes="archiverCampagne"/>
    </b-modal>
    <b-modal v-model="isPopUpDelete"
      has-modal-card
      class="modal">
     <pop-up-prevention
      :messHeader="$t('listeCampagnes.delete.confirmation')"
      :messagesPopup="messagesErreurPopUp"
      :isErrorPopup="errorPopUp"
      :cancel="$t('general.non')"
      :validate="$t('general.oui')"
      @no="isPopUpDelete = false"
      @yes="deleteCampagne"/>
   </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { get, archiver, deleteAsync } from '@/api/campagne/index';
import dropdownButton from '@/components/general/button/dropdownButton';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import { CAMPAGNE } from '@/configuration/permissionsBodacConf';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import formatDate from '@/services/general/formatDate';
import detailCampagne from '@/components/campagne/detailCampagne';
import ongletManager from '@/components/general/ongletManager';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import demandeImpressionStore from '@/store/modules/logistique/demandeImpression';
import listeDemandeImpressionOnglet from '@/components/logistique/demandeImpression/listeDemandeImpressionOnglet';
import * as allTypes from '@/store/mutation-type';
import genererCritereRechercheDemandeImpression from '@/services/logistique/demandeImpression/genererCritereRechercheDemandeImpression';
import { errorViolatesForeignKeyManager } from '@/services/validation/validation';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');

export default {
  name: 'c_campagne',
  components: {
    breadcrumb,
    dropdownButton,
    pieceJointeButton,
    popUpPrevention,
    detailCampagne,
    ongletManager,
    storeRechercheProvider,
    listeDemandeImpressionOnglet,
  },
  data() {
    return {
      campagne: null,
      permCampagne: CAMPAGNE,
      isPopUpArchiver: false,
      isPopUpDelete: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
      demandeImpressionStore,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleDemandeImpression() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeCampagnes.title'), route: { name: 'l.bodac.campagne' }, isActive: false },
        { title: this.$i18n.t('detailCampagne.breadcrumbTitle'), route: '', isActive: true },
      ];
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.' + (this.campagne.actif ? 'archiver' : 'desarchiver')),
          action: () => { this.isPopUpArchiver = true; },
          permissionAction: CAMPAGNE.supprimer,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => {
            this.isPopUpDelete = true;
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
          },
          permissionAction: CAMPAGNE.supprimer,
        },
      ];

      return actions;
    },
    onglets() {
      const onglets = [{
        key: 'detailCampagne',
        title: this.$t('detailCampagne.tab.details'),
      }];
      if (this.moduleDemandeImpression) {
        onglets.push({
          key: 'demandeImpression',
          title: this.$t('detailCampagne.tab.demandeImpression'),
        });
      }
      return onglets;
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    formatDate(date) {
      return formatDate(date);
    },
    async archiverCampagne() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver({
          ids: [this.campagne.id],
          archiver: this.campagne.actif,
        });
        this.isPopUpArchiver = false;
        messageSucces(this.$i18n.t('listeCampagnes.archiverDesarchiver.' + (this.campagne.actif ? 'archiveSuccess' : 'desarchiveSuccess')));
        this.campagne.actif = !this.campagne.actif;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async deleteCampagne() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await deleteAsync(this.campagne.id);
        this.isPopUpDelete = false;
        messageSucces(this.$t('listeCampagnes.delete.success'));
        this.$router.push({ name: 'l.bodac.campagne' });
      } catch (e) {
        if (e.response?.data?.error?.validationErrors) {
          e.response.data.error.validationErrors.forEach(error => {
            errorViolatesForeignKeyManager(error.message, this.messagesErreurPopUp);
          });
          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
      } finally {
        loadingComponent.close();
      }
    },
    changesDemandeImpressionStore() {
      const critere = genererCritereRechercheDemandeImpression();
      critere.campagneIds = [this.campagne.id];
      const initState = {
        items: [],
        total: 0,
        solde: 0,
        maxDatemouvement: null,
        critereRecherche: critere,
        lastPayload: {},
      };
      return {
        state: initState,
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initState;
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.demandeImpression.key]);
      await this.setAttachmentContext({ module: 'Campagne' });
      this.campagne = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.campagne.libelle }));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
